var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":"https://dundeeandangus.ac.uk/studying-at-da/fees-finance-funding/","target":"_blank","text":""}},[_c('v-icon',{attrs:{"left":"","large":""}},[_vm._v("fas fa-question-circle")]),_c('span',{staticClass:"hidden-sm-and-down pl-2"},[_vm._v("Help")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }